module.exports = __webpack_public_path__ + "img/404.aa3d0919.svg";